import { render } from '@testing-library/react'
import React from 'react'
import { Form, Input, Button, Row, Col, Modal, Space } from 'antd';
import ColorPicker from '../ColorPicker';
import {
    LeftOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';
import Colors from '../../config/Colors';
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../../actions';
import { SERVER_CONFIG } from '../../Config';

const layout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 8 },
};

class CreateWidgetInstancePage extends React.Component {

    onFinish = (values) => {
        console.log('Success:', values);
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    constructor(props) {
        super(props);

        this.instanceName = ""
        this.widgetSettings = {}
        this.state = { widgetInstanceData: undefined, previewWidth: 1000, previewHeight: 200, rand: Math.random() }
    }

    receivePoseMessageHandler = (e) => {


        console.log("received post message from iframe : " + JSON.stringify(e.data))
        // this.setState({ widgetsettings: JSON.stringify(e.data) })

        const { action, param } = JSON.parse(e.data);

        switch (action) {
            case "on_setting_change":
                // console.log(param)
                this.widgetSettings = param;
                break;
            case "on_setting_alert":
                const { type = "info", title = "", content = "" } = param;
                switch (type) {
                    case "info":
                        Modal.info({ title: title, content: content });
                        break;
                    case "warning":
                        Modal.warning({ title: title, content: content });
                        break;
                    case "error":
                        Modal.error({ title: title, content: content });
                        break;
                    case "success":
                        Modal.success({ title: title, content: content });
                        break;
                    default:
                        break;
                }
                break;
        }
    }

    componentDidMount() {
        // console.log("componentDidMount")
        window.addEventListener("message", this.receivePoseMessageHandler)

        this.handleNewInstanceData(this.props.widgetInstanceData)

    }

    componentDidUpdate(prevProps) {
        // console.log("componentDidUpdate")
        if (this.props.widgetInstanceData !== prevProps.widgetInstanceData) {
            this.handleNewInstanceData(this.props.widgetInstanceData)
        }
    }

    handleNewInstanceData = (widgetInstanceData) => {
        // console.log("*** handleNewInstanceData " + JSON.stringify(widgetInstanceData))
        if (widgetInstanceData) {
            this.applyInstanceSetting(widgetInstanceData)
        }
        else {
            this.applyInstanceSetting()
        }
    }
    onIFrameLoaded = () => {
        // console.log("iframe loaded")

        const { widgetInstanceData } = this.props

        if (widgetInstanceData) {
            this.applyInstanceSetting(widgetInstanceData)
        }
        else {
            // this.setState{ widgetInstanceData: undefined }
        }
        // this.onSettingsUpdated()
    }
    componentWillUnmount() {
        window.removeEventListener("message", this.receivePoseMessageHandler)
    }

    applyInstanceSetting = (widgetInstanceData) => {
        console.log("widgetInstanceData " + JSON.stringify(widgetInstanceData))

        if (!widgetInstanceData) {
            this.instanceName = "";
            this.widgetSettings = {}
            this.applySettings(this.widgetSettings)
            return;
        }

        this.instanceName = widgetInstanceData.WidgetInstanceName
        this.widgetSettings = JSON.parse(widgetInstanceData.WidgetInstanceSetting)
        this.applySettings(this.widgetSettings, widgetInstanceData ? widgetInstanceData.WidgetInstanceID : "preview")
    }

    applySettings = (settings, target) => {

        console.log("onSettingsUpdated " + target);

        const iframeWin = document.getElementById(`widget-iframe-${target}`)

        if (iframeWin && iframeWin.contentWindow)
            iframeWin.contentWindow.postMessage(JSON.stringify({ action: "on_setting_update", param: settings, target: target }), "*")
    }

    handleSave = () => {
        const { brandID, widgetData, onClose = () => { }, widgetInstanceData, usertoken, requestServerPost, onComplete, selectedBrandData } = this.props;

        if (!("WidgetBrandID" in widgetData)) {
            Modal.warning({ content: "Widget instance must be created under brand" })
            return
        }
        if (this.instanceName === "") {
            Modal.warning({ content: "Please give your instance a name" })
        }
        else {

            const params = new FormData();

            params.append("widgetbrandid", widgetData.WidgetBrandID)
            params.append("widgetinstancename", this.instanceName)
            params.append("widgetinstancesetting", JSON.stringify(this.widgetSettings))
            params.append("widgetid", widgetData.WidgetID)

            if (!widgetInstanceData) {
                params.append("widgetversionid", widgetData.WidgetStableVersionID);
            }

            if (selectedBrandData)
                params.append("brandid", selectedBrandData.brandID)

            if (widgetInstanceData) {
                params.append("widgetinstanceid", widgetInstanceData.WidgetInstanceID);
            }

            // console.log("instancename: " + this.instanceName)
            // console.log("settings: " + JSON.stringify(this.widgetsettings))
            // console.log("widgetid: " + widgetData.WidgetID)
            // console.log("widgetbrandid: " + widgetData.WidgetBrandID)


            const action = widgetInstanceData ? "update_widget_instance" : "create_widget_instance"

            requestServerPost(action, params, {  }, (response) => {
                onComplete();

                Modal.success({
                    content: "Your new instance has been saved"

                })
            }, usertoken);


            // onClose();
        }
    }

    handleFocus = () => {

    }
    onFormChange = (e) => {
        console.log(e)
        console.log(e.target.value)
        switch (e.target.name) {
            case "screenwidth_input":
                this.setState({ previewWidth: e.target.value });
                break;
            case "screenheight_input":
                this.setState({ previewHeight: e.target.value });
                break;
        }
    }
    render() {
        const { widgetData, onClose = () => { }, widgetInstanceData } = this.props;
        const instanceName = widgetInstanceData ? widgetInstanceData.WidgetInstanceName : "";

        // console.log(" instanceName " + instanceName)
        // console.log("widgetData.widgetKey " + JSON.stringify(widgetData))
        return (
            <div style={{ display: "flex", flexDirection: "column", height: "100%", padding: "0px" }}>

                <Row style={{}} justify="space-between" align="middle">
                    <Col> <Row align="middle" style={{ height: "100%" }}>

                        {/* <Col style={{ height: "100%" }}>
    <Button onClick={() => {
        Modal.confirm({
            title: 'Warning',
            icon: <ExclamationCircleOutlined />,
            content: `If you leave now, all the changes will be discarded`,
            okText: 'OK',
            cancelText: 'Cancel',
            onOk: () => onClose()
        });

    }} size="large" style={{ borderWidth: 0, backgroundColor: "#888", height: "100%", width: "70px", color: "white", zIndex: 1000, borderRadius: 0 }} icon={< LeftOutlined />}></Button >

</Col> */}
                        <Col flex style={{ padding: "6px" }}>
                            <Form
                                {...layout}
                                name="basic"
                                initialValues={{ instancename: instanceName }}
                                onValuesChange={(change) => {
                                    if ("instancename" in change) {
                                        // this.setState({ instanceName: change.instancename })
                                        this.instanceName = change.instancename
                                    }
                                }}
                            // onFinish={this.onFinish}
                            // onFinishFailed={this.onFinishFailed}
                            >
                                <Form.Item

                                    // label="What should we call your widget instance? "
                                    name="instancename"
                                    rules={[{ required: true, message: 'Instance name is required!' }]}
                                >
                                    <Input value={instanceName} autoCorrect={false} autoComplete={false} bordered={false} style={{ width: "500px", height: "100%", marginTop: "5px", fontWeight: "normal", fontSize: "22px" }} size="large" placeholder="Type your instance name here!" />
                                </Form.Item>
                            </Form>
                        </Col>

                    </Row>
                    </Col>

                    <Col justify="space-around" style={{ margin: "0px" }}>
                        <Space>
                            {/* PREVIEW SCREEN RATIO
                    <Input.Group compact>
                                <Input
                                    onFocus={this.handleFocus}
                                    name="screenwidth_input"
                                    style={{ width: 100, textAlign: 'center' }}
                                    placeholder="Width"
                                    onChange={this.onFormChange}
                                    value={this.state.previewWidth} />
                                <Input
                                    className="site-input-split"
                                    style={{
                                        width: 30,
                                        borderLeft: 0,
                                        borderRight: 0,
                                        pointerEvents: 'none',
                                    }}
                                    placeholder="x"
                                    disabled
                                    bordered={false}
                                />
                                <Input
                                    onFocus={this.handleFocus}
                                    name="screenheight_input"
                                    className="site-input-right"
                                    style={{
                                        width: 100,
                                        textAlign: 'center',
                                    }}
                                    onChange={this.onFormChange}
                                    value={this.state.previewHeight}
                                    placeholder="Height"
                                />

                            </Input.Group>
                                    px */}
                            <Button onClick={this.handleSave} style={{ margin: "0 20px", width: "150px" }} size="large" type="primary">
                                Save
                            </Button>
                        </Space>
                    </Col>

                </Row>
                <Row style={{ flex: 1, borderRadius: "5px" }}>
                    <Col flex={2} span={24} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <iframe onLoad={this.onIFrameLoaded} id={`widget-iframe-${widgetInstanceData ? widgetInstanceData.WidgetInstanceID : "preview"}`} frameBorder="none" style={{ height: "100%", width: "100%" }} src={`${SERVER_CONFIG.SERVER_URI}widgets/${widgetData.WidgetKey}/preview?viewtype=settingpreview&id=${widgetInstanceData ? widgetInstanceData.WidgetInstanceID : "preview"}&random=${this.state.rand}`}></iframe>

                    </Col>

                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(CreateWidgetInstancePage);